import { createResourceSlice, resourceInitialState } from 'store/ResourceSlice';
import { RequestContactState } from 'typings/state';

export const initialState: RequestContactState = resourceInitialState();

const slice = createResourceSlice({
    name: 'requestContact',
    initialState,
});

export const requestContact = slice.reducer;
export const actions: typeof slice.actions = slice.actions;
